// extracted by mini-css-extract-plugin
module.exports = {"main":"AuthLayout_main__194dn","logo":"AuthLayout_logo__1bFC8"};